/* Progressive enhancement: all links remain available without JavaScript. */
(() => {
  function init(scope = document) {
    scope.querySelectorAll('.berndorf-footer').forEach((footer) => {
      if (footer.dataset.accordionsReady) return;
      footer.dataset.accordionsReady = 'true';
      const media = window.matchMedia('(max-width: 749px)');
      const controls = [...footer.querySelectorAll('[data-footer-toggle]')];
      const setOpen = (button, open) => {
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;
        panel.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
        button.querySelector('span').textContent = open ? '−' : '+';
      };
      const sync = () => controls.forEach((button) => {
        button.hidden = !media.matches;
        button.parentElement.querySelector('[data-footer-label]').hidden = media.matches;
        setOpen(button, !media.matches);
      });
      controls.forEach((button) => button.addEventListener('click', () => {
        setOpen(button, button.getAttribute('aria-expanded') !== 'true');
      }));
      media.addEventListener('change', sync);
      const unload = (event) => {
        if (!event.target.contains(footer)) return;
        media.removeEventListener('change', sync);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      sync();
    });
  }
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
